module.exports = __webpack_public_path__ + "img/LATIN10_20.d21c76e2.jpg";